import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import TokenManager from "../utils/tokenManager";

const AuthProtected = (props: any) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
      // First immediate check
      let token = TokenManager.getToken();
      
      if (!token) {
        // If no token, wait a bit for potential localStorage restoration
        // This handles the timing issue during page refresh
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Check again after the delay
        token = TokenManager.getToken();
      }
      
      setIsAuthenticated(!!token);
      setIsChecking(false);
    };

    checkAuthentication();
  }, []);

  // Show loading state while checking
  if (isChecking) {
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{props.children}</>;
};

export { AuthProtected };